import createIcon from '../../createIcon';

/**
 * @component @name Emergency
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNzkgOS4yM0wxOC43OSA1Ljc3TDE0IDguNTRWM0g5Ljk5OTk2VjguNTRMNS4yMDk5NiA1Ljc3TDMuMjA5OTYgOS4yM0w3Ljk5OTk2IDEyTDMuMjA5OTYgMTQuNzdMNS4yMDk5NiAxOC4yM0w5Ljk5OTk2IDE1LjQ2VjIxSDE0VjE1LjQ2TDE4Ljc5IDE4LjIzTDIwLjc5IDE0Ljc3TDE2IDEyTDIwLjc5IDkuMjNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Emergency = createIcon('Emergency', [
  [
    'path',
    {
      d: 'M20.79 9.23L18.79 5.77L14 8.54V3H9.99996V8.54L5.20996 5.77L3.20996 9.23L7.99996 12L3.20996 14.77L5.20996 18.23L9.99996 15.46V21H14V15.46L18.79 18.23L20.79 14.77L16 12L20.79 9.23Z',
      key: 'lehz3',
    },
  ],
]);

export default Emergency;
